<template>
    <div class="cta-block-module">
        <div class="parallax-wrapper">
            <wp-image :image="background_image"
                      :is-background="true"
                      class="background">
                <div class="content-container">
                    <content-block v-bind="content"></content-block>
                </div>
            </wp-image>
        </div>
    </div>
</template>

<script>
    import ContentBlock from './components/ContentBlock'

    export default {
        name: "ctaBlockModule",
        components: { ContentBlock },
        props: {
            background_image: [Boolean, Object],
            content: Object,
        }
    }
</script>

<style lang="scss" scoped>

    .cta-block-module {
        position: relative;
        width: 100%;
        min-height: 1000px;
        margin: 0 auto;
        @include site-container;

        @media (min-width: $bp-medium) {
            margin-top: -150px;
            width: 90%;
            height: 80vh;
            min-height: 850px;
        }
    }

    .parallax-wrapper {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -22;
    }

    .background {
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: right;
        width: 100%;
        height: 100%;
    }

    .content-container {
        position: absolute;
        bottom: 40px;
        right: 20px;
        left: 20px;
        margin: 0;
        background-color: $white;
        max-width: 500px;

        /deep/ .content-block {
            padding: 0 30px;
        }

        @media (min-width: $bp-medium) {
            top: 50px;
            left: 50px;
            bottom: 50px;
            margin: 0 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            /deep/ .content-block {
                padding: 0 60px;
            }
        }
    }
    
</style>